import { render } from "./Authed.vue?vue&type=template&id=7fbb8ee9"
import script from "./Authed.vue?vue&type=script&lang=js"
export * from "./Authed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__